import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {User} from '../models/user';
import {Observable, of, throwError} from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import {ApiResponse} from '../models/api.response';


const apiUrl = '/gsb/authorities';
@Injectable()
export class AuthorityService {
    constructor(private http: HttpClient) { }

    getAll(): Observable<any> {
      const url = `${apiUrl}/all`;
      return this.http.get<any>(url);
    }

}
